export const fileManagementRoutes: any[] = [];
